import React, { useEffect, useContext } from "react";
import { IdleTimerProvider, DEFAULT_EVENTS } from "react-idle-timer";
import { useAuth } from "./AuthContext";
import { useGlobalFunction } from "./GlobalFunctionContext";
import { GlobalContext } from "./GlobalContext";
import { useLoginModal } from "./LoginModalContext";
import { Navigate, useNavigate } from "react-router-dom";
import { useFlashLoaderLoader } from "./FlashScreenContext";
import { setLoginReturnUrl } from "../Layout/Common/common";

const DEFAULT_SESSION_IDLE_MINUTES = 30;
const configuredIdleMinutes = Number(process.env.REACT_APP_SESSION_IDLE_MINUTES);
const SESSION_IDLE_MINUTES =
  Number.isFinite(configuredIdleMinutes) && configuredIdleMinutes > 0
    ? configuredIdleMinutes
    : DEFAULT_SESSION_IDLE_MINUTES;

const IGNORED_EVENTS = ["mousemove", "MSPointerMove"];
const ACTIVITY_EVENTS = DEFAULT_EVENTS.filter((event) => !IGNORED_EVENTS.includes(event));

const SessionTimeoutProvider = ({ children }) => {
  const { logoutFunction } = useGlobalFunction();
  const { IsTimeout, setIsTimeout } = useContext(GlobalContext);
  const { postAuthentication } = useAuth();
  const navigate = useNavigate();
  const { showLoader, hideLoader } = useFlashLoaderLoader();
  const { showLoginModal, hideLoginModal } = useLoginModal();

  const handleClose = () => {
    setIsTimeout(null);
    hideLoginModal();
    setLoginReturnUrl();
    window.location.replace("/login");
  };

  useEffect(() => {
    if (IsTimeout) {
      showLoginModal({
        title: "Session Expired!. Login to Continue",
        heading: "Welcome. Please Login!",
        onClose: handleClose,
      });
    } else {
      hideLoginModal();
    }
    hideLoader();
  }, [IsTimeout]);

  const checkAuth = async () => {
    var response = await postAuthentication();
    if (response) {
      //window.location.reload(true);
    } else {
      if (!window.location.pathname.toLocaleLowerCase().includes("login")) {
        setIsTimeout(true);
      }
    }
  };

  const handleOnIdle = () => {
    //checkAuth();
  };

  return (
    <IdleTimerProvider
      timeout={1000 * 60 * SESSION_IDLE_MINUTES}
      // promptBeforeIdle={1000 * 60 * (DEFAULT_SESSION_IDLE_MINUTES - 0.1)}
      // onPrompt={checkAuth}
      events={ACTIVITY_EVENTS}
      onIdle={checkAuth}
      debounce={500}
    >
      {children}
    </IdleTimerProvider>
  );
};

export default SessionTimeoutProvider;
